import { Box } from '@mui/material';
import ComponentWithChunks from '@shared/components/others/ComponentWithChunk/ComponentWithChunk';
import PageHeader from '@shared/components/others/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import DefectsContainer from '../components/DefectsContainer';
import { useDefectsChunk } from '../hooks/useDefectsChunk';

const DefectsPage = () => (
    <ComponentWithChunks featuresArray={['defects']} hooksArray={[useDefectsChunk]} Component={DefectsPageComponent} />
);

const DefectsPageComponent = () => {
    const { t } = useTranslation();
    return (
        <Box className="page-container" sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
            <PageHeader title={t('defects')} />
            <Box sx={{ height: 'calc(100vh - 194px)' }}>
                <DefectsContainer />
            </Box>
        </Box>
    );
};

export default DefectsPage;
